import {
    SIGN_IN,
    CEK_COOKIES,
    SIGN_OUT,
    UPLOAD_FILE
} from '../actions/types';

export default (state = {}, action) => {
    switch(action.type){
        case SIGN_IN:
            return action.payload.data;
        case CEK_COOKIES:
            return action.payload.data;
        case UPLOAD_FILE:
            return action.payload.data;
        case SIGN_OUT:
            return state;
        default:
            return state;
    }
}